<template>
    <div class="multiple-choice w-[1200px] h-[100px] fixed " v-if="multipleChoiceshow">
        <div class="bar flex items-center justify-between h-full px-[24px]">
            <div class="left flex items-center gap-[12px]">
                <span class="selected-tip">已选择 {{ selectedCount }} 个资源/文件夹</span>
                <div class="center action-group flex items-center gap-[12px]">
                    <el-button class="action-btn" plain @click="onCopy">
                        <el-icon>
                            <CopyDocument />
                        </el-icon>
                        <span class="ml-[6px]">复制</span>
                    </el-button>
                    <el-button class="action-btn" plain @click="onMove">
                        <el-icon>
                            <FolderOpened />
                        </el-icon>
                        <span class="ml-[6px]">移动</span>
                    </el-button>
                    <!-- <el-button class="action-btn" plain @click="onDownload">
                        <el-icon>
                            <Download />
                        </el-icon>
                        <span class="ml-[6px]">下载</span>
                    </el-button> -->
                    <el-button class="action-btn" plain type="danger" @click="onDelete">
                        <el-icon>
                            <Delete />
                        </el-icon>
                        <span class="ml-[6px]">删除</span>
                    </el-button>
                </div>
            </div>

            <div class="right">
                <el-button link @click="onCancel">取消{{ activeFolder.id }}</el-button>
            </div>
        </div>
        <MoveDialog v-model="moveVisible" :type="'all'" :corp-code="props.corpCode"
            :current="{ folder_id: activeFolder.id || '' }" :multiple="true" :action="moveAction"
            @confirm="onMoveConfirm" />
    </div>
</template>
<script lang="ts" setup>
import { ref, watch, computed } from 'vue'
import { ElButton, ElCheckbox, ElIcon, ElMessage, ElMessageBox } from 'element-plus'
import { CopyDocument, FolderOpened, Download, Delete } from '@element-plus/icons-vue'
import { multipleChoiceStore } from "@/stores/multipleChoice"
import { folderOperate } from "@/api/ResourceMasonry"
//@ts-ignore
import MoveDialog from '@/views/shared/components/MoveDialog.vue'
const multipleChoice = multipleChoiceStore()
const props = defineProps({
    corpCode: { type: String, default: '' },
    activeFolder: { type: Object, default: () => ({}) }
})
const selectedCount = computed(() => multipleChoice.selectedCount)
const multipleChoiceshow = computed(() => multipleChoice.multipleChoice)
const moveVisible = ref(false)
const moveAction = ref('move')


const emit = defineEmits(['refresh'])
const onCopy = () => {
    moveAction.value = 'copy'
    moveVisible.value = true
}
const onMove = () => {
    moveAction.value = 'move'
    moveVisible.value = true
}
const onDownload = () => {

}
const onDelete = () => {
    ElMessageBox.confirm(`确认删除？删除后不可恢复`, '删除资源', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(async () => {
        let resource_ids = multipleChoice.selectedResources.join(',')
        let folder_ids = multipleChoice.selectFolder.join(',')
        await deleteResource(resource_ids)
        await deleteFolder(folder_ids)
        multipleChoice.clearSelected()
        emit('refresh')
        // try {
        //     await folderOperate({ kind: 'resource', action: 'delete', resource_id: item.id, owner_type: props.corpCode ? 'team' : 'user', corp_code: props.corpCode })
        //     // resourceList.value = resourceList.value.filter(x => x.id !== item.id)
        //     // ElMessage.success('资源已删除')
        //     // detailVisible.value = false
        // } catch { }
    }).catch(() => { })
}
const onCancel = () => { multipleChoice.clearSelected(); }
const onMoveConfirm = async () => {
    moveVisible.value = false
    multipleChoice.clearSelected()
    emit('refresh')
}
const deleteFolder = async (ids) => {
    if (!ids) return
    try {
        await folderOperate({ kind: 'folder', action: 'delete', folder_id: ids, owner_type: props.corpCode ? 'team' : 'user', corp_code: props.corpCode })
        return
    } catch {
        return
    }
}
const deleteResource = async (ids) => {
    if (!ids) return
    try {
        await folderOperate({ kind: 'resource', action: 'delete', resource_id: ids, owner_type: props.corpCode ? 'team' : 'user', corp_code: props.corpCode })
        return
    } catch {
        return
    }
}

</script>
<style scoped lang="scss">
.multiple-choice {
    border-radius: 4px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    background-color: #f7fafd9a;
    padding: 10px;
    bottom: 100px;
    left: 50%;
    transform: translateX(-50%);
    border: 1px solid white;
    backdrop-filter: blur(10px);
}

.bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
}

.selected-tip {
    color: #8a8f99;
    font-size: 14px;
}

.action-group .action-btn {
    height: 36px;
    border-radius: 6px;
}

.right .el-button {
    color: #2a66ff;
}
</style>
